import React from 'react';
import ReactDOM from 'react-dom/client';
import './index/index.css';
import App from './app/App';
import { msalInitPromise, msalInstance } from './msalInstance';
import { MsalProvider } from '@azure/msal-react';

// Wait for MSAL to initialize and handle any popup redirect
// BEFORE rendering React. This is critical for the Microsoft
// login popup to close properly after authentication.
msalInitPromise.then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});